import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isKnowledgePath, langFromPath } from '../lib/contentLocale';

function LocaleSync() {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!isKnowledgePath(location.pathname)) return;
    const pathLang = langFromPath(location.pathname);
    if (pathLang !== i18n.language.split('-')[0]) {
      i18n.changeLanguage(pathLang);
    }
  }, [location.pathname, i18n]);

  return null;
}

export default LocaleSync;
